import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { BasicService } from '../../shared/services/basic.service';
import { UserProfileComponent } from '../../user-profile/user-profile.component';
import { TaskProcessContext } from '../shared/task-process-context.class';

@Component({
  selector: 'app-task-process-page-header',
  templateUrl: './task-process-page-header.component.html',
  styleUrls: ['./task-process-page-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaskProcessPageHeaderComponent {
  @Input() taskProcessContext: TaskProcessContext;
  @Output() backClicked = new EventEmitter<void>();

  constructor(private basicService: BasicService) {}

  onBackClicked($event) {
    this.backClicked.emit($event);
  }

  openUserProfile() {
    const modalInput = {
      taskProcessContext: this.taskProcessContext,
    };
    this.basicService.cardModal(UserProfileComponent, modalInput);
  }
}
